<div
  class="header-part"
  fxLayout="row"
  fxLayoutAlign="start"
  fxLayoutGap="16px"
>
  <ng-container [ngSwitch]="iconType">
    <app-avatar *ngSwitchCase="'avatar'" [name]="name" [size]="32"></app-avatar>
    <ng-container *ngSwitchCase="'none'"></ng-container>
    <mat-icon *ngSwitchDefault class="icon">{{ iconType }}</mat-icon>
  </ng-container>

  <div fxLayout="column" fxFlex style="overflow: hidden">
    <div fxLayout="row" fxLayoutAlign="start center">
      <app-info class="name" [tooltip]="tooltip">{{ name }}</app-info>
      <app-badge *ngIf="showAiGeneratedBadge" class="ai-generated-badge" [small]="true">{{ 'aiAdoption.aiGenerated' | translate }}</app-badge>
    </div>
    <span *ngIf="time !== undefined && time !== null" class="subtitle">{{ time | durationHms }}</span>
    <span
      *ngIf="subtitle"
      class="subtitle"
      [matTooltip]="subtitleTooltip || ''"
      [matTooltipDisabled]="!subtitleTooltip"
    >{{ subtitle }}</span>
  </div>


  <div class="right-container">
    <ng-container *ngIf="rightSideTemplate" [ngTemplateOutlet]="rightSideTemplate"></ng-container>
    <button *ngIf="showCloseButton" mat-icon-button (click)="close()" class="compact">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
